export default __webpack_public_path__ + "static/media/pp.c9fa00d6.jpg";